import { StoreAction, XmAction } from 'store/actions';
import { AddonCollections } from './addon-collections';

export function addonsCollectionReducer(state: AddonCollections[] = [], action: XmAction<AddonCollections>): AddonCollections[] {
    let newState: AddonCollections[];

    switch (action.type) {
        case StoreAction.GET_ADDONS_COLLECTION:
            newState = state.filter((item: AddonCollections) => item.lineId !== action.payload.lineId);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_ADDONS_COLLECTION:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            return state.filter((item: AddonCollections) => item.lineId !== action.filters.lineId);
        default:
            return state;
    }
}
